// === onLoad_premium.js START ====================================================================

$(function () {

    // Note: Using const here will break gulp
    var $mcTemplate = $('#m-premium__multicard-tmpl');
    var $ppTemplate = $('#m-premium__prepaid-tmpl');

    if (!$mcTemplate.length || !$ppTemplate.length) {
        return;
    }

    var mcTemplate = Handlebars.compile($mcTemplate.html());
    var ppTemplate = Handlebars.compile($ppTemplate.html());

    // Prepaid Card
    var prepaidUpdateFunction = function () {
        ApiClient.getActivePrepaidCard().done(function (result) {
            if (typeof result.data !== 'object'
                || result.data.balance === 0) return;
            console.info("Showing prepaid info:", result.data);

            var premiumInfo = $('.m-mamp-premium-info');

            if (result.data.balance === 0 && !premiumInfo.html()) return;

            // remove previous container
            $(".prepaid-card-balance-container").remove();

            premiumInfo.append(ppTemplate(result.data));
        });
    };
    prepaidUpdateFunction();
    window.prepaidUpdateFunction = prepaidUpdateFunction;

    if (calendarConfiguration.calendarType != 'Appliances') {
        // MultiCard
        ApiClient.getActiveMultiCard().done(function (result) {
            if (typeof result.data !== 'object') return;
            console.info("Showing multicard info:", result.data);

            result.data.unitsRemaining = result.data.unitsTotal - result.data.unitsUsed;
            $('.m-mamp-premium-info').append(mcTemplate(result.data));

            window.currentMultiCard = result.data;
        });
    }



});

// === onLoad_premium.js END ======================================================================
